import {FiBarChart2} from "react-icons/fi";
import {Link, useLocation} from "react-router";

import {Button} from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {METRICS_EXPLORER} from "@/lib/featureFlags.ts";
import {buildExplorerLink} from "@/pages/metricsExplorer/checkPreset.ts";

interface ExploreMetricsButtonProps {
  checkId: number;
  checkType: string;
}

/**
 * Opens the explorer on this check, carrying over the date range the user is looking at.
 * Transaction checks arrive with their per-step breakdown already on the chart.
 */
export const ExploreMetricsButton = ({checkId, checkType}: ExploreMetricsButtonProps) => {
  const {userHasFeature} = useCurrentUserContext();
  const {search} = useLocation();

  if (!userHasFeature(METRICS_EXPLORER)) {
    return null;
  }

  return (
    <Button variant="secondary" size="large" as={Link} to={buildExplorerLink(checkId, checkType, search)}>
      <Icon icon={FiBarChart2} /> Explore Metrics
    </Button>
  );
};
